import { MODULES } from '@configs/modules.enum';

export const MODULE_PRIORITY: MODULES[] = [
  MODULES.PORTFOLIO,
  MODULES.RUG,
  MODULES.AIVA,
  MODULES.COMPANY,
  MODULES.DATA_STUDIO,
  MODULES.FINANCIAL,
  MODULES.SHELL_ADMIN,
];
